import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type OptimizationDashboard } from '../../api/optimization';

export function PlatformHealthOverviewPage() {
  const [dash, setDash] = useState<OptimizationDashboard | null>(null);
  useEffect(() => { void optimizationApi.dashboard().then(setDash); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Platform Health Overview</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {dash?.platform_health?.map((m) => (
          <div key={m.module} className="rounded-xl border p-4 dark:border-slate-700">
            <p className="font-medium capitalize">{m.module}</p>
            <p className={`text-sm ${m.status === 'healthy' ? 'text-green-600' : m.status === 'degraded' ? 'text-amber-600' : 'text-red-600'}`}>{m.status}{m.latency_ms != null ? ` · ${m.latency_ms}ms` : ''}</p>
          </div>
        )) ?? <p className="text-sm text-slate-500">Loading platform health…</p>}
      </div>
    </div>
  );
}
